import axios from "axios";

const smsService = axios.create({
    baseURL: process.env.VUE_APP_SUPPORT,
    timeout: 30000,
    withCredentials: true
});
smsService.defaults.headers['Product'] = 'vsp';

smsService.interceptors.request.use(res => {
    res.headers["token"] = JSON.parse(localStorage.getItem("USER")) ? JSON.parse(localStorage.getItem("USER")).token : '';
    return res;
})

smsService.interceptors.response.use(
    response => {
        if (response.data.errCode === 1) {
            window.$vm.$Message.error(response.data.errMsg);
            return Promise.reject(response.data);
        }

        return response.data;
    },

    error => {
        window.$vm.$Message.error(error.response.data.errMsg);
        return Promise.reject(error)
    }
);

export default {
    SendCode(phoneNumber) {
        return smsService.post(`/sms/sendCode/vsp/${phoneNumber}`);
    },
  // 获取图形验证码
  GetVerifyImg (params) {
    return smsService.post(`/captcha/captcha/get`,params)
  },
  // 校验图形验证码
  CheckVerifyImg (params) {
    return smsService.post(`/captcha/captcha/check`,params)
  },
  // 新接口-发送手机验证码
  SendCodeNew (phoneNumber,captchaVerification) {
    return smsService.post(`/sms/sendCode/vsp/${phoneNumber}`, captchaVerification)
  }
};